import request from '@/utils/request'
// 嘉宾接口

export function getPersonInfo (query) {
    return request({
        url: 'media-reporter/info',
        method: 'get',
        params: query
    })
}

export function submitInfo (data) {
    return request({
        url: 'notcheck/register/media',
        method: 'post',
        data
    })
}

export function updateInterview (data) {
    return request({
        url: 'media-reporter/interview',
        method: 'put',
        data
    })
}

export function updateActivity (data) {
    return request({
        url: 'media-reporter/activity',
        method: 'put',
        data
    })
}
